import React from 'react';
import { t } from '@lingui/macro';
import { getClonedChild } from '@landr/maestro';
import { TabNames } from 'types/enums';
import { DetailsPane } from '../types';
import DetailsView from '../DetailsView';
import findChildPosition from './findChildPosition';

const sortByPosition = (a: DetailsPane, b: DetailsPane) => {
    if (a?.position === undefined || b?.position === undefined) {
        return 0;
    }

    return a.position - b.position;
};

const getTabsInOrder = (tabs: DetailsPane[]) => {
    tabs.sort(sortByPosition);

    return {
        firstTab: tabs[0],
        secondTab: tabs[1],
    };
};

const getDetailsViewTabs = ({
    childrenArray,
}: {
    childrenArray: (
        | React.ReactChild
        | React.ReactFragment
        | React.ReactPortal
    )[];
}) => {
    const dropdownSorting = getClonedChild(
        childrenArray,
        DetailsView.DropdownSorting,
    );
    const samplesChild = getClonedChild(
        childrenArray,
        DetailsView.SamplesPane,
        {
            dropdownSorting,
        },
    );
    const packsChild = getClonedChild(childrenArray, DetailsView.PacksPane, {
        dropdownSorting,
    });

    const samplesTab = {
        name: TabNames.Samples,
        displayName: t`Samples`,
        position: findChildPosition(childrenArray, 'DetailsView.SamplesPane'),
        content: samplesChild,
        appended:
            React.isValidElement(samplesChild) && samplesChild?.props?.appended,
    };

    const packsTab = {
        name: TabNames.Packs,
        displayName: t`Packs`,
        position: findChildPosition(childrenArray, 'DetailsView.PacksPane'),
        content: packsChild,
        appended:
            React.isValidElement(packsChild) && packsChild?.props?.appended,
    };

    const { firstTab, secondTab } = getTabsInOrder([samplesTab, packsTab]);

    return { firstTab, secondTab };
};

export default getDetailsViewTabs;
